
<template>
  <div class="header pt3-ns">
    <div>
      <div class="nav flex justify-between items-center">
        <div class="nav__logo">
          <router-link class="logo link fw6 pa2 ttc flex items-center" :to="{name: 'home'}">
            <img class="logo__img" v-bind:src="logoUrl">
            <span class="logo__text ml3">{{siteName}}</span>
          </router-link>
        </div>

        <div class="nav__links tr">
          <div class="pt4 pt0-m pt0-l mt1">
            <component v-bind:is="languageDropdownComponent"></component>
          </div>

          <div v-if="showMembersBar === false" class="pt3 mt1">
            <a :href="loginLink" class="link fw6 pa2">{{$t('loginLinkText')}}</a>
            <a :href="signupLink" class="link fw6 pa2 ml1">{{$t('signupLinkText')}}</a>
          </div>
          <div v-else class="pt3 mt1">
            <a :href="MALink" class="link fw6 pa2">{{$t('MALinkText')}}</a>
          </div>
        </div>
      </div>

      <div class="stage">
        <div class="row-container">
          <h1 class="stage__title">{{$t('headerTitle')}}</h1>
          <h5 class="stage_title--sub">{{$t('headerTitleDescription')}}</h5>
        </div>
        <component v-bind:is="searchBarComponent"></component>
        <div class="row-container">
          <p class="stage__text">
            <span
              class="stage__text__question text--theme-highlight fw4"
            >{{$t('popularQuestionsText')}}</span>
            <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[0]}-${popularQuestionOne.title.replace(/ /g, '-')}`}"
            >{{popularQuestionOne.title}}</router-link>
            <span class="text--theme-highlight">&nbsp;|&nbsp;</span>
            <router-link
              class="link fw4"
              :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[1]}-${popularQuestionTwo.title.replace(/ /g, '-')}`}"
            >{{popularQuestionTwo.title}}</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getComponent, getSpecificArticleFromStore, checkUserAuth } from '@/utils/common'

export default {
  data: () => {
    return {
      showMembersBar: false
    }
  },
  methods: {
    checkForMember() {
      if ((this.$route.query.a_l === '1') || (window.localStorage.getItem('a_l') === '1')) {
        window.localStorage.setItem('a_l', '1')
        if (checkUserAuth()) {
          this.showMembersBar = true
          return
        }
      }
      this.showMembersBar = false
    }
  },
  created() {
    this.checkForMember()
  },
  computed: {
    languageDropdownComponent() {
      return getComponent(this.$store.getters.flowObject, 'languageDropdown')
    },
    siteName() {
      return this.$store.state.siteDetails.site_name
    },
    loginLink() {
      return `https://members.${
        this.$store.state.siteDetails.domain_name
      }/login`
    },
    MALink() {
      return `https://members.${
        this.$store.state.siteDetails.domain_name
      }`
    },
    signupLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/signup`
    },
    logoUrl() {
      return this.$store.state.siteDetails.logo_url
    },
    popularQuestionOne() {
      return getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0])
    },
    popularQuestionTwo() {
      return getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1])
    },
    searchBarComponent() {
      return getComponent(this.$store.getters.flowObject, 'searchBar')
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  max-width: 1160px;
  margin: 0 auto;
  position: relative;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
// Remove this when we want to return to normal DOM flow...
.nav__links {
  position: relative;
  top: 1rem;
  padding-right: 0.4rem;
}
// end of removal

.logo__img {
  width: 40px;
}
.logo__text {
  font-size: 19.5px;
  font-weight: 400;
}

.stage {
  text-align: center;

  .link:hover {
    text-decoration: underline;
  }
}

.stage__title {
  font-size: 23px;
  font-family: 'Lato', sans-serif;
  font-weight: 900 !important;
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  margin-bottom: 0.4rem;
  padding-top: 0.8rem;
  color: #2b2b2b;
}
.stage_title--sub {
  font-size: 12px;
  font-family: 'Lato', sans-serif;
  padding: 0 1rem 0;
  font-weight: 400;
  margin: 0;
  margin-bottom: 2.9rem;
  color: #8c8c8c;
  letter-spacing: 0.03rem;
}

.stage__text {
  padding-left: 1rem;
  padding-right: 1rem;
  margin-top: 1.75rem;
  font-size: 0.875rem;

  .link {
    color: black;
  }
  .stage__text__question {
    display: block;
  }
}

@media (min-width: 426px) {
  .logo__text {
    font-size: 25.5px;
  }
}
@media (min-width: 641px) {
  .header {
    margin-bottom: 1rem;
  }
  .nav {
    padding: 0 5%;
    height: 71px;
  }
  .stage__title {
    font-size: 42px;
  }
  .stage__text {
    font-size: 1rem;
    margin-top: 1.2rem;

    .stage__text__question {
      display: inline;
    }
  }
}

@media (min-width: 832px) {
  .header {
    margin-bottom: 7rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .stage__title {
    padding-top: 0;
    margin-top: -0.7rem;
  }
  .stage_title--sub {
    margin-top: 1.9rem;
    margin-bottom: 1.25rem;
    font-size: 18px;
  }
  .stage__text {
    margin-top: 1rem;
  }
}

@media (min-width: 960px) {
  .header {
    margin-bottom: 6.5rem;
  }
  .nav {
    max-width: 70em;
    padding: 0 0.5rem;
  }
}
</style>
